module.exports = __webpack_public_path__ + "product-bg.jpg?7794667bab305054e3fe917f7d5ce556";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-bg.jpg
// module id = 10
// module chunks = 0